import { theme } from '@buggy/shared'

export const colors = Object.values(theme.colors.chart).slice(0, 5)
export const statesWithoutHoverAndActive = {
  hover: {
    filter: {
      type: 'none',
    },
  },
  active: {
    filter: {
      type: 'none',
    },
  },
}
